import React from "react";
import { Link } from "react-router-dom";
import services from "../../../data/services.json";
function ServiceArea() {
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <section className="service-area sec-pad">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-4 col-xl-4">
              <div className="title">
                <span>Nos expertises</span>
                <h2>
                  Sites web, apps et design qui transforment vos idées en
                  résultats concrets.
                </h2>
                <div className="cmn-btn">
                  <Link
                    onClick={scrollTop}
                    to={`${process.env.PUBLIC_URL}/service`}
                  >
                    Voir tous les services
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-8 col-xl-8">
              <div className="row g-4">
                {services.map((service, index) => (
                  <div
                    key={service.id}
                    className="col-sm-6 col-md-6 col-lg-6 col-xl-6"
                  >
                    <div className="single-service">
                      <span className="count">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <div className="service-icon">
                        <i>
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              `/images/icons/service-icon-${index + 1}.png`
                            }
                            alt={service.title}
                          />
                        </i>
                      </div>
                      <div className="service-content">
                        <h4>{service.title}</h4>
                        <p>{service.descriptions.home}</p>
                        <Link
                          onClick={scrollTop}
                          to={`${process.env.PUBLIC_URL}/service-details/${service.slug}`}
                        >
                          En savoir plus
                          <i>
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/images/icons/arrow-circle.png"
                              }
                              alt={`En savoir plus sur ${service.title}`}
                            />
                          </i>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ServiceArea;
